
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  person: string = "";
  companyId: string;
  public openUser: boolean = false;



  constructor(private _Router: Router, ) {
    // this.EmployeeName = localStorage.getItem("CamelgateName");
    // this.camle = JSON.parse(localStorage.getItem("companyId"));

    // this.camle =this.companyId==null?  true:false
  }
  toggleUser() {
    this.openUser = !this.openUser;
  }
  ngOnInit() {
    this.person = localStorage.getItem("username");
   }

  logout() {
    const role = +localStorage.getItem("Authorization");
    // window.location.reload(); 
    localStorage.clear();
    this._Router.navigate([""]);

  }
  Profile() {
    this.companyId = localStorage.getItem("");

    // this._CompanyService.Data.next(this.companyId);
  }
}
